<template>
  <div
    id="app"
    :class="[$tvaMq]"
    :version="version"
    :style="{
      backgroundImage: backGroundColor,
    }"
  >
    <!-- <MobileDisclaimer v-if="$tvaMq === 'tablet' || $tvaMq === 'mobile'" /> -->
    <!-- v-else -->
    <template>
      <transition name="fade" mode="out-in">
        <router-view :key="$route.params.path"></router-view>
      </transition>
    </template>
  </div>
</template>

<script>
import { version } from "@/../package.json";
import { mapActions } from "vuex";

// import MobileDisclaimer from "@/views/MobileDisclaimer";

import bgColor from "@/mixins/bgColor";
export default {
  name: "App",
  mixins: [bgColor],
  data() {
    return {
      version,
    };
  },
  beforeCreate() {
    let lang;
    if (this.$route.params.lang) {
      lang = this.$route.params.lang;
    } else {
      lang = "en";
      this.$route.params.lang = lang;
    }
    this.$i18n.locale = lang.toLowerCase();

    // Set html language attribute
    document.querySelector("html").setAttribute("lang", lang.toLowerCase());
  },
  mounted() {
    this.setVHProperty();

    window.addEventListener("resize", this.setVHProperty);
    window.addEventListener("orientationchange", this.setVHProperty);

    this.loadConfig();
    this.loadData();
  },
  watch: {
    $route(to) {
      if (this.$route.params.lang) {
        this.$i18n.locale = to.params.lang.toLowerCase();
      }
      if (to.name === "landing") {
        // reset landig index when the user navigates to landing
        this.setIndexFromMenu(-1);
      }
    },
  },
  methods: {
    setVHProperty() {
      if (this.$tvaMq === "mobile") {
        let vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty("--vh", `${vh}px`);
      }
    },
    ...mapActions({
      loadConfig: "ui/loadConfig",
      loadData: "data/loadData",
      setIndexFromMenu: "scroller/setIndexFromMenu",
    }),
  },
  // components: {
  //   MobileDisclaimer,
  // },
};
</script>

<style lang="scss">
html,
body,
div,
span,
applet,
object,
iframe,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
pre,
a,
abbr,
acronym,
address,
big,
cite,
code,
del,
dfn,
em,
img,
ins,
kbd,
q,
s,
samp,
small,
strike,
strong,
tt,
var,
b,
u,
i,
center,
dl,
dt,
dd,
ol,
ul,
li,
fieldset,
form,
label,
legend,
table,
caption,
tbody,
tfoot,
thead,
tr,
th,
td,
article,
aside,
canvas,
details,
embed,
figure,
figcaption,
footer,
header,
hgroup,
menu,
nav,
output,
ruby,
section,
summary,
time,
mark,
audio,
video {
  margin: 0;
  padding: 0;
  border: 0;
  font-size: 100%;
  font: inherit;
  vertical-align: baseline;
}
/* HTML5 display-role reset for older browsers */
article,
aside,
details,
figcaption,
figure,
footer,
header,
hgroup,
menu,
nav,
section {
  display: block;
}
body {
  line-height: 1;
  overscroll-behavior: none;
  // TODO: FRIN: This causes issues on my side but is done by frin for a reason, check why
  overflow: hidden !important;
}

html {
  scroll-snap-type: y mandatory;
  // hide horizontal scrollbar
  width: 100%;
  overflow-x: hidden;
  // overflow: hidden !important;
}

ol,
ul {
  list-style: none;
}
blockquote,
q {
  quotes: none;
}
blockquote:before,
blockquote:after,
q:before,
q:after {
  content: "";
  content: none;
}
table {
  border-collapse: collapse;
  border-spacing: 0;
}

a,
button {
  color: inherit;
  font-family: inherit;
  font-size: inherit;
  font-weight: inherit;
  line-height: inherit;
  padding: 0;
}
button {
  background-color: transparent;
  border: none;

  &:hover:not(:disabled) {
    cursor: pointer;
  }
}
a {
  text-decoration: none;
}

*,
::before,
::after {
  box-sizing: border-box;
  -webkit-tap-highlight-color: transparent;
}

#app {
  font-family: "Ideal Sans", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: ui-whitescale;
  user-select: none;
  height: 100vh;
  overflow: hidden;
}
// overwrite style for eni's cookie banner
body {
  #onetrust-consent-sdk {
    margin: 0;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
      "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji",
      "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5;
    color: #333;
    text-align: left;
    background-color: #fff;
  }
}
</style>
